var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.72 27.72",
    style: {
      enableBackground: "new 0 0 27.72 27.72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.28,23.014l-8.158-7.048c-0.525-0.524-1.25-0.729-1.933-0.619c2.847-3.749,2.568-9.129-0.851-12.548 c-3.733-3.732-9.807-3.732-13.539,0c-3.731,3.732-3.731,9.807,0,13.539c3.42,3.42,8.8,3.697,12.548,0.852 c-0.108,0.683,0.095,1.404,0.619,1.933l7.048,8.16c0.87,0.871,2.839,0.312,3.709-0.557C27.596,25.853,28.151,23.885,27.28,23.014z  M14.114,14.112c-2.506,2.505-6.582,2.505-9.088,0c-2.507-2.505-2.506-6.583,0-9.087c2.504-2.505,6.582-2.506,9.086,0 C16.618,7.53,16.618,11.608,14.114,14.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.684,9.34c-0.005-0.435-0.36-0.782-0.796-0.777c-0.437,0.005-0.781,0.36-0.777,0.795 c0.02,1.655,0.672,3.212,1.844,4.384c0.309,0.307,0.808,0.307,1.113,0c0.309-0.307,0.309-0.805,0-1.113 C6.188,11.749,5.698,10.581,5.684,9.34z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.5561d885.svg";
export { ForwardRef as ReactComponent };